
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  SubcontractorSearchResultResource,
  ValidationError,
} from '../models';
import {
    SubcontractorSearchResultResourceFromJSON,
    SubcontractorSearchResultResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface SearchSubcontractorsRequest {
    searchText?: string;
    notCompliant?: boolean;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class SubcontractorSearchApi extends runtime.BaseAPI {

    /**
     * Search for subcontractor companies (admin endpoint)
          */
    async searchSubcontractorsRaw(requestParameters: SearchSubcontractorsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SubcontractorSearchResultResource>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['notCompliant'] != null) {
            queryParameters['notCompliant'] = requestParameters['notCompliant'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SubcontractorSearchResultResource>({
            path: `/compliance/api/subcontractor/admin/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SubcontractorSearchResultResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Search for subcontractor companies (admin endpoint)
          */
    async searchSubcontractors(requestParameters: SearchSubcontractorsRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SubcontractorSearchResultResource> {
        const response = await this.searchSubcontractorsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
